import { useCallback, useEffect, useState } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaSearch } from 'react-icons/fa';
import { FaFilter, FaFilterCircleXmark } from "react-icons/fa6";
import { Header, ScrollProps } from '../../components/Header';
import { IPropsCorretor } from '../../types';
import { BsPatchCheckFill } from 'react-icons/bs';

import {
    Container,
    ContainerPage,
    Content
} from './styles';

import { Footer } from '../../components/Footer';
import { useAuth } from '../../context/auth';
import { GoToTop } from '../../GoToTop';
import { ConfigProvider, Input, Select, Space, Table } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import ptBR from 'antd/es/locale/pt_BR';
import Loading from './Loading';

interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
}


export function CommissionDetails() {

    const { user, api } = useAuth()

    const id = user.id_corretor

    const [corretor, setCorretor] = useState<IPropsCorretor>({} as IPropsCorretor)
    // const [categorys, setCategorys] = useState<ICategorys[]>([])

    const loadData = useCallback(async () => {
        await api.get(`/portal/corretor/${id}`).then(res => {
            setCorretor(res.data)
        })
    }, [id, api])

    const loadCategorys = useCallback(async () => {
        await api.get('/portal/category').then(res => {
            // setCategorys(res.data)
            // console.log('categorys', res.data)
        })
    }, [api])

    useEffect(() => {
        loadData()
        loadCategorys()
    }, [loadData, loadCategorys])

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(true)

    const [scrollTop, setScrollTop] = useState<ScrollProps>({ y: 0, lastY: 0 } as ScrollProps);
    const [show, setShow] = useState(false);
    const [search, setSearch] = useState('');

    const [showFilters, setShowFilters] = useState(false);

    const [searchText, setSearchText] = useState('');

    const columns: TableColumnsType<DataType> = [
        {
            title: 'Name',
            dataIndex: 'name',
            filters: [
                {
                    text: 'Joe',
                    value: 'Joe',
                },
                {
                    text: 'Category 1',
                    value: 'Category 1',
                },
                {
                    text: 'Category 2',
                    value: 'Category 2',
                },
            ],
            filterMode: 'tree',
            filterSearch: true,
            onFilter: (value, record) => record.name.startsWith(value as string),
            width: '30%',
        },
        {
            title: 'Age',
            dataIndex: 'age',
            sorter: (a, b) => a.age - b.age,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            filters: [
                {
                    text: 'London',
                    value: 'London',
                },
                {
                    text: 'New York',
                    value: 'New York',
                },
            ],
            onFilter: (value, record) => record.address.startsWith(value as string),
            filterSearch: true,
            width: '40%',
        },
    ];

    const data: DataType[] = [
        {
            key: '1',
            name: 'John Brown',
            age: 32,
            address: 'New York No. 1 Lake Park',
        },
        {
            key: '2',
            name: 'Jim Green',
            age: 42,
            address: 'London No. 1 Lake Park',
        },
        {
            key: '3',
            name: 'Joe Black',
            age: 32,
            address: 'Sydney No. 1 Lake Park',
        },
        {
            key: '4',
            name: 'Jim Red',
            age: 32,
            address: 'London No. 2 Lake Park',
        },
    ];

    const [filteredData, setFilteredData] = useState(data);

    const handleSearch = () => {
        if (filteredData.length === 0) {
            setFilteredData(data)
        }
        const lowercasedSearchText = searchText.toLowerCase();
        const filtered = data.filter(item =>
            item.name.toLowerCase().includes(lowercasedSearchText) ||
            item.address.toLowerCase().includes(lowercasedSearchText)
        );
        setFilteredData(filtered);
    };

    const handleClear = () => {
        setSearchText('');
        setFilteredData(data);
    };

    const onChange: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
    };

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTop = event.currentTarget.scrollTop;
        setScrollTop(prevState => { return { y: scrollTop, lastY: prevState.y } })
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // Altera o estado de loading para false após 5 segundos
        }, 5000); // 5000 milissegundos = 5 segundos

        // Limpeza do timer quando o componente for desmontado
        return () => clearTimeout(timer);
    }, []);

    // const buildFix: IBuildindCorretor[] = useMemo(() => {
    //   return building.filter(b => b.is_fixado === 1)
    // }, [building])

    return (
        <Container onScroll={handleScroll}>
            <Header show={show} setShow={setShow} scroll={scrollTop} search={search} setSearch={setSearch} />
            {
                loading &&
                <Loading />
            }
            {
                !loading &&
                <>

                    <Content show={show}>
                        <div className='header'>
                            <img className='placeholder-header' src={corretor?.banner_empresa ? corretor?.banner_empresa : '/images/placeholder-header-corretor.jpg'} alt="background header corretor" />
                            {
                                corretor?.banner_empresa === '' &&
                                <img className='logo-white' src={'/images/logo-hub-capacete-white.png'} alt="logo hub nogueira branco" />
                            }
                        </div>
                        <div className='body'>
                            {
                                corretor?.foto_perfil ?
                                    <img src={corretor?.foto_perfil} className='avatar' alt='avatar' />
                                    :
                                    <img src={'/images/placeholder-avatar-corretor.jpg'} className='avatar' alt='avatar' />
                            }
                            <div className='title-and-others'>
                                <div className='title-and-infos'>
                                    <p className='name-corretor'>{corretor?.nome}</p>
                                    <p className='class'>Especialista Nogueira <BsPatchCheckFill className='check-corretor' /></p>
                                    <p className='creci'>CRECI {corretor?.creci}</p>
                                </div>
                                <div className='icons-social-midias'>
                                    {
                                        (corretor?.instagram !== null && corretor?.instagram !== '' && corretor?.instagram !== " ") &&
                                        <a href={`https://${corretor?.instagram}`} target='_blank' rel='noreferrer'><FaInstagram className='icons-midias' /></a>
                                    }
                                    {
                                        (corretor?.facebook !== null && corretor?.facebook !== '' && corretor?.facebook !== " ") &&
                                        <a href={`https://${corretor?.facebook}`} target='_blank' rel='noreferrer'><FaFacebookF className='icons-midias' /></a>
                                    }
                                    {
                                        (corretor?.linkedin !== null && corretor?.linkedin !== '' && corretor?.linkedin !== " ") &&
                                        <a href={`https://${corretor?.linkedin}`} target='_blank' rel='noreferrer'><FaLinkedinIn className='icons-midias' /></a>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='traco' />


                        <ContainerPage>

                            <ConfigProvider locale={ptBR}>

                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                                    <h2 style={{ width: "fit-content", fontWeight: 600 }}>Suas Comissões</h2>

                                    <Space style={{ marginBottom: 16, marginLeft: "auto", display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end", width: "fit-content" }}>

                                        <Input
                                            placeholder="Pesquise"
                                            value={searchText}
                                            onChange={(e) => { setSearchText(e.target.value); handleSearch(); }}
                                            onPressEnter={handleSearch}
                                            style={{ width: 300, height: 40 }}
                                            allowClear
                                            onClear={handleClear}

                                        />
                                        <FaSearch onClick={handleSearch} size={20} style={{ cursor: "pointer", color: "#979797" }} />

                                        {!showFilters && <FaFilter onClick={() => setShowFilters(!showFilters)} size={20} style={{ cursor: "pointer", color: "#979797" }} />}
                                        {showFilters && <FaFilterCircleXmark onClick={() => setShowFilters(!showFilters)} size={21} style={{ cursor: "pointer", color: "#979797" }} />}

                                        {/* <button style={{ width: "fit-content", padding: "5px 10px", height: "40px", color: "#fff", background: "#e26217", display: "flex", alignItems: "center", justifyContent: "center", gap: "3px", border: "none", borderRadius: "5px", cursor: "pointer" }}
                                            onClick={handleClear}>
                                            <FaTrash /> Limpar
                                        </button> */}
                                    </Space>
                                </div>

                                {showFilters &&
                                    <>
                                        <hr style={{ color: "#CACACA", opacity: "0.6", height: "1px", marginTop: "20px", marginBottom: "20px", borderStyle: "dashed" }} />

                                        <div className='filters'>
                                            <div className='filter-input'>
                                                <label>Filtro 1</label>
                                                <Select placeholder="Selecione uma opção" style={{ height: 40 }}>
                                                    <Select.Option value="1">Opção 1</Select.Option>
                                                    <Select.Option value="2">Opção 2</Select.Option>
                                                    <Select.Option value="3">Opção 3</Select.Option>
                                                </Select>
                                            </div>
                                            <div className='filter-input'>
                                                <label>Filtro 1</label>
                                                <Select placeholder="Selecione uma opção" style={{ height: 40 }}>
                                                    <Select.Option value="1">Opção 1</Select.Option>
                                                    <Select.Option value="2">Opção 2</Select.Option>
                                                    <Select.Option value="3">Opção 3</Select.Option>
                                                </Select>
                                            </div>
                                            <div className='filter-input'>
                                                <label>Filtro 1</label>
                                                <Select placeholder="Selecione uma opção" style={{ height: 40 }}>
                                                    <Select.Option value="1">Opção 1</Select.Option>
                                                    <Select.Option value="2">Opção 2</Select.Option>
                                                    <Select.Option value="3">Opção 3</Select.Option>
                                                </Select>
                                            </div>
                                            <div className='filter-input'>
                                                <label>Filtro 1</label>
                                                <Select placeholder="Selecione uma opção" style={{ height: 40 }}>
                                                    <Select.Option value="1">Opção 1</Select.Option>
                                                    <Select.Option value="2">Opção 2</Select.Option>
                                                    <Select.Option value="3">Opção 3</Select.Option>
                                                </Select>
                                            </div>
                                            <div className='filter-input'>
                                                <button style={{ display: "flex", alignItems: "center", gap: "3px", backgroundColor: "#0E2244", color: "#fff", padding: "5px 15px", height: "40px", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                                                    <FaFilter size={20} />
                                                    Filtrar
                                                </button>
                                            </div>
                                        </div>

                                    </>
                                }

                                <div style={{ marginTop: '1rem' }}>
                                    <Table<DataType> columns={columns} dataSource={filteredData} onChange={onChange} />
                                </div>


                            </ConfigProvider>


                        </ContainerPage>


                    </Content>

                    <GoToTop />
                    <Footer />
                </>
            }

        </Container >
    );
}